import React from "react";

import Error403 from "./Error403";
import ErrorComponent from "./Error";
import { useFetch, ApiError, is403ApiError } from "../../hooks/FetchHook";
import Loader from "./Loader";
interface FetchWrapperProps {
  endpointSuffix?: string;

  children: (data: any, refetch: () => void) => React.ReactNode;
  extraQueryKey?: string;
  endpointPrefix?: string;
  method?: "GET" | "POST" | "PUT" | "DELETE";

  body?: any;
  mockError?: ApiError; //Use it like this in the component: mockError={{ status: 500, message: "Forbidden" }}
}

type FetchWrapperStateProps = {
  data: any;
  isLoading: boolean;
  error: unknown;
  refetch?: () => void;
  children: (data: any, refetch: () => void) => React.ReactNode;
  mockError?: ApiError;
};

const noopRefetch = () => {};

export const FetchWrapperState: React.FC<FetchWrapperStateProps> = ({
  data,
  isLoading,
  error,
  refetch = noopRefetch,
  children,
  mockError,
}) => {
  const effectiveError = mockError || error;

  if (isLoading && !mockError) {
    return (
      <div
        data-testid="fetch-wrapper-loading"
        className="flex justify-center items-center"
      >
        <Loader />
      </div>
    );
  }

  if (effectiveError) {
    return (
      <div
        data-testid="fetch-wrapper-error"
        className="flex mt-[100px] justify-center items-center"
      >
        {is403ApiError(effectiveError) ? <Error403 /> : <ErrorComponent />}
      </div>
    );
  }

  return <>{children(data, refetch)}</>;
};

const FetchWrapper: React.FC<FetchWrapperProps> = ({
  endpointPrefix,
  endpointSuffix,
  children,
  extraQueryKey = "",
  method = "GET",
  body,
  mockError,
}) => {
  const { data, isLoading, error, refetch } = useFetch({
    endpointSuffix: endpointSuffix ?? "",
    extraQueryKey,
    endpointPrefix,
    method,
    body,
  });

  return (
    <FetchWrapperState
      data={data}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      mockError={mockError}
    >
      {children}
    </FetchWrapperState>
  );
};

export default FetchWrapper;
